import React, {useEffect, useState} from 'react';
import {requestPriorityInputUsers} from "@app/services/UserService";
import {PriorityInputUserStatus} from "@app/constants/Common";

const PriorityInputList = (props) => {
    const [users, setUsers] = useState([]);
    // const [userLoginInfo, setUserLoginInfo] = useState({});

    const {candidateId} = props

    const fetchPriorityInputUsers = () => {
        let params = {candidate_id: candidateId}
        requestPriorityInputUsers(params).then(res => {
            setUsers(res.content);
        });
    };

    useEffect(() => {
        // if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
        //     setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        // }
        fetchPriorityInputUsers()
    }, [candidateId])

    // <td className={user.is_active ? 'text-success' : 'text-danger'}>{user.is_active ? 'Active' : 'Blocked'}</td>
    const displayStatusValue = (status) => {
        if (PriorityInputUserStatus.APPROVED === status) {
            return 'Đã duyệt'
        }
        if (PriorityInputUserStatus.REJECTED === status) {
            return 'Từ chối'
        }
        if (PriorityInputUserStatus.WAITING === status) {
            return 'Đang chờ'
        }
        return ''
    }

    const displayStatusClass = (status) => {
        if (PriorityInputUserStatus.APPROVED === status) {
            return 'text-success'
        }
        if (PriorityInputUserStatus.REJECTED === status) {
            return 'text-danger'
        }
        return ''
    }
    return (
        <div className='container-fluid'>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title'><b>Danh sách users NL trong thời gian ưu tiên</b></h3>
                </div>
                <div className='card-body'>
                    <table
                        className='table table-hover table-bordered'
                    >
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>User</th>
                            <th>Ngày NL</th>
                            <th>Trạng thái</th>
                        </tr>
                        </thead>
                        <tbody>
                        {users.map((u, index) => {
                            return <tr key={`pri_user_item_${index}`}>
                                <td>{index + 1}</td>
                                <td>{u.username}</td>
                                <td>{u.inputted_date_time}</td>
                                <td className={displayStatusClass(u.status)}>{displayStatusValue(u.status)}</td>
                            </tr>
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PriorityInputList;
